var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Arrow/right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 10 0 10 10 0 10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03a-Dashboard---Default",
    transform: "translate(-748.000000, -116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Arrow/right",
    transform: "translate(748.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(5.000000, 5.000000) scale(-1, 1) translate(-5.000000, -5.000000) "
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99114732,3.96914093 L3.46767888,3.96914093 L5.72347348,1.71889552 C6.11692603,1.32522842 6.11692603,0.687910594 5.72347348,0.295250321 C5.32901208,-0.0984167736 4.69040833,-0.0984167736 4.29695579,0.295250321 L0.295846049,4.28729643 C-0.0986153497,4.68096353 -0.0986153497,5.31828136 0.295846049,5.71094163 L4.29695579,9.70500138 C4.49368206,9.90133152 4.75194835,10 5.01021463,10 C5.26848092,10 5.52573835,9.90133152 5.72347348,9.70500138 C6.11692603,9.31234111 6.11692603,8.67401646 5.72347348,8.28135619 L3.42026281,5.98278336 L8.99114732,5.98278336 C9.54904285,5.98278336 10,5.53172745 10,4.97596214 C10,4.42019683 9.54904285,3.96914093 8.99114732,3.96914093",
    id: "Fill-1",
    fill: "current"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6641737a1c82e32c341ce3219b01e1ce.svg";
export { ForwardRef as ReactComponent };